import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  Observable
} from '@apollo/client';
import { createSessionLink } from './sessionLink';

const GRAPHQL_SLOW_REQUEST_THRESHOLD_MS = 3000;
const httpLink = new HttpLink({ uri: process.env.REACT_APP_OFFKEY_GRAPH_URL });
const authLink = createSessionLink();

const loggingLink = new ApolloLink((operation, forward) => {
  return new Observable((observer) => {
    const startedAt = Date.now();
    const operationName = operation.operationName || 'anonymous';

    const observable = forward(operation);
    const subscription = observable.subscribe({
      next: (result) => {
        const durationMs = Date.now() - startedAt;

        if (result.errors?.length) {
          console.error('[graphql] Operation returned errors', {
            operationName,
            variables: operation.variables,
            durationMs,
            errors: result.errors
          });
        } else if (durationMs >= GRAPHQL_SLOW_REQUEST_THRESHOLD_MS) {
          console.info('[graphql] Slow operation', {
            operationName,
            variables: operation.variables,
            durationMs
          });
        }

        observer.next(result);
      },
      error: (error) => {
        const durationMs = Date.now() - startedAt;

        console.error('[graphql] Operation failed', {
          operationName,
          variables: operation.variables,
          durationMs,
          message: error?.message,
          networkError: error?.networkError,
          graphQLErrors: error?.graphQLErrors
        });

        observer.error(error);
      },
      complete: () => {
        observer.complete();
      }
    });

    return () => subscription.unsubscribe();
  });
});

const link: any = ApolloLink.from([authLink, loggingLink, httpLink]);
export const apolloClient = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      CompleteUserInstance: {
        keyFields: (obj) => {
          // Assert obj as any to bypass TypeScript's type checking
          const userInstance = (obj as any).UserInstance;
          // Check if userInstance is an object and has an 'Id' property
          if (
            typeof userInstance === 'object' &&
            userInstance !== null &&
            'Id' in userInstance
          ) {
            return `CompleteUserInstance:${userInstance.Id}`;
          }
          return '';
        }
      },
      CompleteUserDefinition: {
        keyFields: (obj) => {
          // Assert obj as any to bypass TypeScript's type checking
          const userDefinition = (obj as any).UserDefinition;
          // Check if userInstance is an object and has an 'Id' property
          if (
            typeof userDefinition === 'object' &&
            userDefinition !== null &&
            'Id' in userDefinition
          ) {
            return `CompleteUserDefinition:${userDefinition.Id}`;
          }
          return '';
        }
      },
      UserInstance: {
        keyFields: ['Id']
      }
    }
  }),
  link,
  connectToDevTools: true
});
